import type { AssetDetails } from 'modules/queries/asset/useDetails';
import type { DrawerProps } from '@liquidweb-dev/undercurrent/Drawer';
import AddAcronisBackupSettings from './Add';
import UpdateAcronisBackupSettings from './Update';

interface AcronisBackupSettingsProps extends DrawerProps {
	assetDetails: AssetDetails;
	onDestroy: () => void;
	onClose: () => void;
}

const AcronisBackupSettings: React.FC<AcronisBackupSettingsProps> = ({
	assetDetails,
	...rest
}) => {
	const hasAcronis =
		assetDetails?.hasAcronis && assetDetails?.acronisStatus === 'Active';

	if (hasAcronis) {
		return (
			<UpdateAcronisBackupSettings assetDetails={assetDetails} {...rest} />
		);
	}

	return <AddAcronisBackupSettings assetDetails={assetDetails} {...rest} />;
};

export default AcronisBackupSettings;
